module.exports = __webpack_public_path__ + "img/ranger-station.1723c41b.webp";